// Product page: magnify the gallery image under the mouse (mouse only; touch keeps the normal swipe).
// Uses event delegation so it keeps working when the gallery is re-rendered (variant change).
(() => {
  const SELECTOR = '.product-media-container:not(.dialog-zoomed-gallery *) .product-media';

  const mediaFrom = (target) => {
    const media = target instanceof Element ? target.closest(SELECTOR) : null;
    return media && media.querySelector('img') ? media : null;
  };

  document.addEventListener('pointerover', (event) => {
    const media = mediaFrom(event.target);
    if (!media || event.pointerType !== 'mouse') return;
    media.classList.add('emeltec-zoom');
  });

  document.addEventListener('pointermove', (event) => {
    const media = mediaFrom(event.target);
    if (!media || event.pointerType !== 'mouse') return;
    const box = media.getBoundingClientRect();
    media.style.setProperty('--zoom-x', `${((event.clientX - box.left) / box.width) * 100}%`);
    media.style.setProperty('--zoom-y', `${((event.clientY - box.top) / box.height) * 100}%`);
    media.classList.add('is-zooming');
  });

  document.addEventListener('pointerout', (event) => {
    const media = mediaFrom(event.target);
    if (!media || media.contains(event.relatedTarget)) return;
    media.classList.remove('is-zooming');
  });
})();
